(() => {
  const mobileDrawer = document.querySelector(".js-mobile-filter-menu");

  const openDrawer = document.querySelector(
    ".js-collection-display__filter-opener"
  );

  const closeDrawerBtn = mobileDrawer.querySelectorAll(
    ".js-filter-collection__close"
  );

  const deleteAllFilters = document.querySelectorAll(
    ".js-filter-collection__delete"
  );

  function closeDrawer() {
    mobileDrawer.close();
    document.body.classList.remove("remove-scrolling");
  }

  openDrawer.addEventListener("click", () => {
    mobileDrawer.showModal();
    document.body.classList.add("remove-scrolling");
  });

  closeDrawerBtn.forEach((closer) => {
    closer.addEventListener("click", () => {
      closeDrawer();
    });
  });

  deleteAllFilters.forEach((deleteBtn) => {
    deleteBtn.addEventListener("click", () => {
      const allFilters = document.querySelectorAll("filter-search-custom");
      allFilters.forEach((filter, index) => {
        filter.resetFilters(index === allFilters.length - 1);
      });
    });
  });

  mobileDrawer.addEventListener("click", (e) => {
    const dialogDimensions = mobileDrawer.getBoundingClientRect();
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      closeDrawer();
    }
  });
})();
